import { LookupDTO, LookupConfigDTO, LookupCustomConfig } from './../models/lookup.model';
import { environment } from './../../environments/environment';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ComplexLinqPredicateDTO, LinqPredicateDTO } from '../models/linqPredicate.model';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  /**
   * Variabile di appoggio che restituirà le informazioni alla chiusura della lookup in aggiunta (es: ID utente appena salvato)
   */
  lookupAddingComplete: EventEmitter<any> = new EventEmitter<any>();

  constructor(private http: HttpClient) {
  }

  /**
   * Data una stringa con il nome dell'entità, restituisce un array di LookupDTO dell'entità precedentemente passata
   * @param entityType Nome dell'entità
   */
  GetLookupEntities(entityType: string, filters: Array<LinqPredicateDTO> = null, complexFilters: Array<ComplexLinqPredicateDTO> = null, customConfig: LookupCustomConfig = null, namespaceClass: string = null): Promise<Array<LookupDTO>> {
    let config: LookupConfigDTO = new LookupConfigDTO();
    config.TypeName = entityType;
    config.Filters = filters;
    config.CustomConfig = customConfig;
    config.ComplexFilters = complexFilters;
    config.NamespaceClass = namespaceClass;
    return this.http.post<Array<LookupDTO>>(environment.apiFullUrl + '/lookup/GetLookupEntities', config).toPromise()
  }

  /**
   * Restituisce l'elenco completo di tutte le aziende (non cancellate logicamente) presenti sul DB da usare in una lookup
   * @returns
   */
  GetCompanyLookupEntities(): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/lookup/GetCompanyLookupEntities').toPromise()
  }


}
